import { type LayoutContainerWidth } from 'noddi-ui-web';
import { useContext, useEffect } from 'react';
import { PageLayoutContext } from './PageLayoutContext';

export const usePageWidth = (): LayoutContainerWidth | undefined => {
  return useContext(PageLayoutContext)?.width;
};

export const useSetPageWidth = (width: LayoutContainerWidth | undefined) => {
  const ctx = useContext(PageLayoutContext);
  useEffect(() => {
    if (!ctx) {
      return;
    }
    ctx.setWidth(width);
    return () => ctx.setWidth(undefined);
  }, [ctx, width]);
};
